export default function<T extends object> (rawString = ''): T | undefined {
  let parsed;
  try {
    parsed = JSON.parse(rawString);
  } catch (e) {
    console.error(`JSON string "${rawString}" couldn't be parsed`);
  }

  return parsed;
}
